import React from 'react';

const PEARL_CONNECT_CHECK_PATH =
    'M5.01218 10.812C5.08814 10.7063 5.12266 10.6384 5.171 10.5856C8.12978 7.3472 11.092 4.10883 14.0542 0.87046C14.2648 0.640226 14.4133 0.610031 14.5548 0.761004C14.6895 0.908203 14.655 1.09315 14.4582 1.30828C11.4131 4.64101 8.36454 7.96996 5.32291 11.3065C5.10195 11.5518 4.93278 11.548 4.71872 11.3102C3.20654 9.64954 1.6909 7.99638 0.17871 6.34323C0.137281 6.29794 0.0923982 6.25642 0.0613259 6.20735C-0.0284386 6.07148 -0.0180811 5.9356 0.0820409 5.81105C0.17871 5.69404 0.340977 5.67895 0.458361 5.77708C0.503244 5.81482 0.541221 5.86389 0.582651 5.90541C2.01198 7.46798 3.43785 9.02677 4.86373 10.5893C4.91206 10.6422 4.94659 10.7101 5.01218 10.812Z';

export const PearlConnectPlanCheckmark = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        {...props}
    >
        <path d={PEARL_CONNECT_CHECK_PATH} fill="#4A8280" />
    </svg>
);
